import { render, staticRenderFns } from "./club.vue?vue&type=template&id=8d2c7908"
import script from "./club.vue?vue&type=script&lang=js"
export * from "./club.vue?vue&type=script&lang=js"
import style0 from "./club.vue?vue&type=style&index=0&id=8d2c7908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports